// extracted by mini-css-extract-plugin
export default {"body":"body-BSBFt","correctRow":"correctRow-NRRyg","row":"row-QFnxf","description":"description-t1c0G","hint":"hint-Zx1v3","footer":"footer-zHNdt"};